import {
  WeatherPartlyCloudy,
  WeatherFog,
  WeatherSnow,
  WeatherRain,
  WeatherSleet,
  WeatherSun,
  WeatherCloudy,
} from "@fanduel/formation-react-icons";

interface WeatherIconProps {
  condition: string;
  width: number;
  height: number;
}

const EXACT_CONDITION_TO_ICON: {
  [key: string]: React.FC<{ width: number; height: number }>;
} = {
  sunny: WeatherSun,
  fair: WeatherSun,
  clear: WeatherSun,
  "partly sunny": WeatherPartlyCloudy,
  "partly cloudy": WeatherPartlyCloudy,
  overcast: WeatherPartlyCloudy,
  "mostly cloudy": WeatherCloudy,
  cloudy: WeatherCloudy,
  rain: WeatherRain,
  "light rain": WeatherRain,
  "light snow": WeatherSnow,
  snow: WeatherSnow,
  sleet: WeatherSleet,
};

const WeatherIcon = ({ condition, width, height }: WeatherIconProps) => {
  const conditionStr = condition.toLowerCase();
  const Icon = EXACT_CONDITION_TO_ICON[conditionStr] as React.FC<{
    width: number;
    height: number;
  }>;

  if (Icon) return <Icon width={width} height={height} />;

  // Keyword search as a fallback
  switch (true) {
    case conditionStr.includes("rain"):
    case conditionStr.includes("thunder"):
      return <WeatherRain width={width} height={height} />;
    case conditionStr.includes("sun"):
      return <WeatherSun width={width} height={height} />;
    case conditionStr.includes("sleet"):
      return <WeatherSleet width={width} height={height} />;
    case conditionStr.includes("snow"):
      return <WeatherSnow width={width} height={height} />;
    case conditionStr.includes("fog"):
      return <WeatherFog width={width} height={height} />;
    case conditionStr.includes("cloud"):
      return <WeatherCloudy width={width} height={height} />;
    default:
      return <WeatherSun width={width} height={height} />;
  }
};

export default WeatherIcon;
